import { BodyText } from "@/components/ui/Text";
import { cn } from "@/lib/utils";
import { formatDate } from "date-fns";
import type { ReactNode } from "react";

interface MessageBubbleProps {
  children: ReactNode;
  timestamp: string | Date;
  variant?: "default" | "async" | "system";
  className?: string;
  footer?: ReactNode;
}

export const MessageBubble = ({
  children,
  timestamp,
  variant = "default",
  className,
  footer,
}: MessageBubbleProps) => {
  const getBubbleStyle = () => {
    switch (variant) {
      case "async":
        return "bg-secondary";
      case "system":
        return "bg-transparent text-center";
      default:
        return "bg-info";
    }
  };

  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <div
        className={cn(
          "flex flex-col gap-1 p-3 rounded-lg rounded-bl-none",
          getBubbleStyle(),
        )}
      >
        {children}
      </div>
      <div className="flex items-center gap-2">
        <BodyText size="xs" textColor="tertiary">
          {formatDate(new Date(timestamp), "MM/dd/yyyy h:mm a")}
        </BodyText>
        {footer && <div className="flex-1">{footer}</div>}
      </div>
    </div>
  );
};
